export default class StepManager {
  // eslint-disable-next-line space-before-function-paren
  constructor(...steps) {
    this.steps = steps;
    this.currentStep = 0;
  }

  nextStep () {
    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
    }
  }

  previousStep () {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  getStep () {
    return this.steps[this.currentStep];
  }

  isFirstStep () {
    return this.currentStep === 0;
  }

  isLastStep () {
    return this.currentStep === this.steps.length - 1;
  }

  isActive (key) {
    const step = this.steps[this.currentStep];

    if (Array.isArray(step)) {
      return ~step.indexOf(key);
    } else {
      // eslint-disable-next-line eqeqeq
      return step == key;
    }
  }
}
